
import React from 'react'
import TableLayout from '../../../components/TableLayout'
import moment from 'moment'

const DiscountsListContainer = () => {
    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Descripción',
            dataIndex: 'description',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Tipo de descuento',
            dataIndex: 'type',
            sorter: true,
            filtered: false,
            render: (label, row) => {
                if (row.type == 'item_based') {
                    return 'Basado en articulos';
                }

                if (row.type == 'quantity_based') {
                    return 'Basado en la cantidad';
                }

                if (row.type == 'mixed') {
                    return 'Descuento mixto';
                }
                return ''
                
            }
        },
        {
            title: 'Fecha inicio',
            dataIndex: 'date_from',
            sorter: true,
            filtered: true,
            dataType: 'date',
            render: (label) => {
                return label ? moment(label).format('DD/MM/YYYY') : ''
            }
        },
        {
            title: 'Fecha fin',
            dataIndex: 'date_to',
            sorter: true,
            filtered: true,
            dataType: 'date',
            render: (label) => {
                return label ? moment(label).format('DD/MM/YYYY') : ''
            }
        },
        {
            title: 'Creación',
            dataIndex: 'created_at',
            filtered: true,
            sorter: true,
        },
        {
            title: 'Actualizacíón',
            dataIndex: 'updated_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
        },
    ]

    return (
        <>
            <TableLayout
                title="Listado de descuentos"
                columns={columns}
                resource="discounts"
                actions={['excel','pdf', 'active', 'create', 'edit', 'show']}
            />
        </>
    )
}

export default DiscountsListContainer
